import React from 'react';

class SandwichPage extends React.Component {

	render() {

		return (
		<div className="container">
			<div className="alert alert-primary">
				<h4>Before your results...</h4>
				<p>
                I write a free weekly newsletter called <em>"Chinese Grammar Gems"</em>: short, clear explanations of one Mandarin grammar point each week. If you're learning Chinese, I think you'll enjoy it.
				</p>
				<div>
                    <button className="btn btn-primary btn-doyoucontinue" type="button">
                        <a href="https://hsklevel.substack.com" role="button" onClick={(e) => this.props.onSeeResults(e)}
                            target="_blank" rel="noreferrer noopener" style={{color:'white', textDecoration: 'none'}}>
                            Take a look
                        </a>
                    </button>
                    <p>Your results are ready. Click above to check out the newsletter, then come back for your score.</p>
	            </div>
			</div>
		</div>
		);
	}
}


export default SandwichPage